import { BLOCKCHAIN_NAME } from 'src/core/blockchain/models/blockchain-name';

export const owlToSupportedBlockchains = [
    BLOCKCHAIN_NAME.ETHEREUM,
    BLOCKCHAIN_NAME.BINANCE_SMART_CHAIN,
    BLOCKCHAIN_NAME.ZK_FAIR,
    BLOCKCHAIN_NAME.SCROLL,
    // BLOCKCHAIN_NAME.STARKNET,
    BLOCKCHAIN_NAME.BASE,
    BLOCKCHAIN_NAME.ZK_SYNC,
    BLOCKCHAIN_NAME.LINEA,
    BLOCKCHAIN_NAME.ARBITRUM,
    BLOCKCHAIN_NAME.OPTIMISM,
    BLOCKCHAIN_NAME.POLYGON_ZKEVM,
    BLOCKCHAIN_NAME.POLYGON,
    BLOCKCHAIN_NAME.KROMA,
    BLOCKCHAIN_NAME.MANTA_PACIFIC,
    BLOCKCHAIN_NAME.METIS,
    BLOCKCHAIN_NAME.XLAYER,
    BLOCKCHAIN_NAME.MANTLE,
    BLOCKCHAIN_NAME.BLAST,
    BLOCKCHAIN_NAME.ZETACHAIN,
    BLOCKCHAIN_NAME.MERLIN,
    BLOCKCHAIN_NAME.MODE,
    BLOCKCHAIN_NAME.TAIKO,
    BLOCKCHAIN_NAME.CORE,
    BLOCKCHAIN_NAME.BITLAYER,
    BLOCKCHAIN_NAME.GRAVITY,
    BLOCKCHAIN_NAME.SONIC,
    BLOCKCHAIN_NAME.MORPH,
    BLOCKCHAIN_NAME.FRAXTAL
] as const;

export type OwlToSupportedBlockchain = (typeof owlToSupportedBlockchains)[number];
